import React from 'react'
import * as styles from './FooterLinks.module.css'

import FooterLink from './FooterLink'

export default class FooterLinks extends React.Component {
  render() {
    return (
      <footer>
        <aside className={styles.footerlinks}>
          <ul>
            <FooterLink href={'/about'}>
              <h3>About Me</h3>
              <p>
                Find out more about me: Where do I come from? What's my favorite
                dessert? Which songs do I sing in the shower? My deepest
                secreeeets...{' '}
              </p>
            </FooterLink>
            <FooterLink href={'/notes'}>
              <h3>Notes</h3>
              <p>
                As I learn new stuff I like to keep notes. These are my notes
                made public! Lots of interesting and helpful stuff with no
                filters!
              </p>
            </FooterLink>
            <FooterLink
              href={'https://www.youtube.com/channel/UCCbO782lk1tvKgc7uU14mZQ'}
              target="_blank"
            >
              <h3>Videos</h3>
              <p>
                I sometimes make videos on YouTube. They are highly weird and
                quirky. Don't miss the bloopers at the end! Enjoy!
              </p>
            </FooterLink>
            <FooterLink href={'/projects'}>
              <h3>Projects</h3>
              <p>
                Here you can find the results of my tinkering. Labor of love
                side projects from the past, present and future.
              </p>
            </FooterLink>
            <FooterLink href={'/'}>
              <h3>Blog</h3>
              <p>
                This is where I write awesome articles on wondrous topics and
                unearth the misteries of the universe... and JavaScript.
              </p>
            </FooterLink>
            <FooterLink href={'/newsletter'}>
              <h3>Newsletter</h3>
              <p>
                The Barbarian Meets Coding Newsletter! A place where you get a
                look behind the scenes of Barbarian Meets Coding, a peek inside
                ma brain and whatever I'm working on.
              </p>
            </FooterLink>
            <FooterLink href={'/now'}>
              <h3>Now</h3>
              <p>
                Find out what I'm doing right now! (Right right now, I'm writing
                this text)
              </p>
            </FooterLink>
            <FooterLink href={'/books'}>
              <h3>Books</h3>
              <p>
                I love writing! Here you can find more about the books I've
                written and those that I'm planning on writing.
              </p>
            </FooterLink>

            <FooterLink href={'/speaking'}>
              <h3>Speaking</h3>
              <p>
                On occasion I speak at conferences and meetups. I love to put on
                a show, and teach and entertain in equal measure. See where I'll
                be speaking next.
              </p>
            </FooterLink>

            <FooterLink href={'/reading'}>
              <h3>Reading</h3>
              <p>
                Reading is a passion of mine. Take a sneak peek at the books
                I've read and the ones I'm reading.
              </p>
            </FooterLink>
            <FooterLink href={'/blog/archives'}>
              <h3>Archives</h3>
              <p>A list of all the articles I've written in this blog.</p>
            </FooterLink>
          </ul>
        </aside>
      </footer>
    )
  }
}
